var ComponentListenerImpl = /** @class */ (function () {
    function ComponentListenerImpl(owner, componentId, onComponentAddedRef, onComponentUpdatedRef, onComponentRemovedRef) {
        this.ownerSystem = owner;
        this.componentId = componentId;
        this.onComponentAddedRef = onComponentAddedRef;
        this.onComponentUpdatedRef = onComponentUpdatedRef;
        this.onComponentRemovedRef = onComponentRemovedRef;
    }
    ComponentListenerImpl.prototype.onAdd = function (entity, newComponent) {
        this.onComponentAddedRef(entity, newComponent);
    };
    ComponentListenerImpl.prototype.onUpdate = function (entity, oldComponent, newComponent) {
        this.onComponentUpdatedRef(entity, oldComponent, newComponent);
    };
    ComponentListenerImpl.prototype.onRemove = function (entity, oldComponent) {
        this.onComponentRemovedRef(entity, oldComponent);
    };
    return ComponentListenerImpl;
}());
export { ComponentListenerImpl };
//# sourceMappingURL=ComponentListenerImpl.js.map